import { render, staticRenderFns } from "./OpenIdList.vue?vue&type=template&id=9c8a65a6"
import script from "./OpenIdList.vue?vue&type=script&lang=js"
export * from "./OpenIdList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports